export default __webpack_public_path__ + "static/media/aventure-vivant.c7df89e5.jpg";